module.exports = __webpack_public_path__ + "static/media/Petshop-No-Ar-2.f8da7ba8.jpg";